<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="schedulingPopup()"
          >新增排班</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="name" label="排班名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.name }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="classesName" label="班次"> </el-table-column>
      <el-table-column prop="startDate" label="起始日期">
        <template slot-scope="scope">
          {{ scope.row.startDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="endDate" label="结束日期">
        <template slot-scope="scope">
          {{ scope.row.endDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="生产地址"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="schedulingPopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="schedulingDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 新增排班 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="schedulingFormVisible" center>
      <el-form
        :model="schedulingForm"
        :size="$store.state.formSize"
        :rules="schedulingFormRules"
        ref="refschedulingForm"
        label-width="140px"
      >
        <el-form-item label="排班名称：" prop="name">
          <el-input
            v-model="schedulingForm.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="起始日期：" prop="startDate">
          <el-date-picker
            v-model="schedulingForm.startDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            placeholder="选择起始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="endDate">
          <el-date-picker
            v-model="schedulingForm.endDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            placeholder="选择起始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班次：" prop="classesId">
          <el-select style="width:100%" v-model="schedulingForm.classesId" placeholder="请选择">
            <el-option
              v-for="item in classesList"
              :key="item.id"
              :label="item.classesName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="带班领导：" prop="manageIds">
          <el-select style="width:100%" v-model="schedulingForm.manageIds" multiple placeholder="请选择">
            <el-option
              v-for="item in manageList"
              :key="item.id"
              :label="item.userName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员：" prop="userIds">
          <el-select style="width:100%" v-model="schedulingForm.userIds" multiple placeholder="请选择">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.userName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生产地址：" prop="address">
          <el-input v-model="schedulingForm.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="schedulingForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawer" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>排班详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">排班名称</td>
            <td>{{ detailDate.name }}</td>
            <td class="list-item">班次名称</td>
            <td>{{ detailDate.classesName }}</td>
          </tr>
          <tr>
            <td class="list-item">起始日期</td>
            <td>{{ detailDate.startDate | formatDate }}</td>
            <td class="list-item">结束日期</td>
            <td>{{ detailDate.endDate | formatDate }}</td>
          </tr>
          <tr>
            <td class="list-item">带班领导</td>
            <td>
              <p v-for="(item) in detailDate.manages" :key="item.userId">{{ item.userName }}</p>
            </td>
            <td class="list-item">人员</td>
            <td>
              <p v-for="(item) in detailDate.users" :key="item.userId">{{ item.userName }}</p>
            </td>
          </tr>
          <tr>
            <td class="list-item">生产地址</td>
            <td>{{ detailDate.address }}</td>
            <td class="list-item">备注</td>
            <td>{{ detailDate.remark }}</td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import { getUserList } from '@/api/user'
import { getClassesList } from '@/api/classes'
import {
  getSchedulingList,
  putSchedulingAdd,
  getSchedulingDetail,
  postSchedulingEdit,
  deleteSchedulingDel,
  delSchedulingList
} from '@/api/scheduling'
const createForm = () => ({
  address: '',
  name: '',
  classesId: '',
  startDate: '',
  endDate: '',
  manageIds: [],
  userIds: [],
  remark: '',
  classesName: ''
})

export default {
  data() {
    return {
      schedulingFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      tableData: [],
      drawer: false,
      detailDate: {},
      schedulingForm: createForm(),
      manageList: [],
      userList: [],
      classesList: [],
      currentID: null,
      isDisabled: false,
      schedulingFormRules: {
        name: [
          { required: true, message: '请输入排班名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请选择生产地址', trigger: 'blur' }
        ],
        classesId: [
          { required: true, message: '请选择班次', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择起始日期', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'blur' }
        ],
        manageIds: [
          { required: true, message: '请选择带班领导', trigger: 'blur' }
        ],
        userIds: [
          { required: true, message: '请选择人员', trigger: 'blur' }
        ]
      },
      loading: true,
      selectionID: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑排班' : '新建排班'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.schedulingSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delSchedulingList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getSchedulingListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.schedulingFormVisible = false
      this.$set(this, 'schedulingForm', createForm())
      this.$refs.refschedulingForm.clearValidate()
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getSchedulingListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getSchedulingListData()
    },
    citySelect(event) {
      if (event.length > 2) {
        this.schedulingForm.province = parseInt(event[0].split(',')[1])
        this.schedulingForm.city = parseInt(event[1].split(',')[1])
        this.schedulingForm.county = parseInt(event[2].split(',')[1])
      }
    },
    townSelect(event) {
      this.schedulingForm.town = parseInt(event.split(',')[1])
    },
    // 删除排班
    schedulingDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteSchedulingDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除排班成功')
              this.getSchedulingListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/修改排班
    schedulingSubmit() {
      this.$refs.refschedulingForm.validate(valid => {
        if (!valid) return false
        const changeScheduling = this.currentID
          ? postSchedulingEdit
          : putSchedulingAdd
        changeScheduling({
          address: this.schedulingForm.address,
          name: this.schedulingForm.name,
          classesId: this.schedulingForm.classesId,
          startDate: this.schedulingForm.startDate,
          endDate: this.schedulingForm.endDate,
          manageIds: this.schedulingForm.manageIds,
          userIds: this.schedulingForm.userIds,
          remark: this.schedulingForm.remark,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑排班成功') : this.$message.success('新增排班成功')
            this.schedulingFormVisible = false
            this.getSchedulingListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开新增/修改表单
    schedulingPopup(id) {
      this.$set(this, 'schedulingForm', createForm())
      const isAdd = !id
      this.schedulingFormVisible = true

      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getSchedulingDetail(id).then(res => {
          if (res.status === 1) {
            this.schedulingForm.name = res.data.name
            this.schedulingForm.remark = res.data.remark
            this.schedulingForm.startDate = moment(res.data.startDate).format('YYYY-MM-DD')
            this.schedulingForm.endDate = moment(res.data.endDate).format('YYYY-MM-DD')
            this.schedulingForm.classesId = res.data.classesId
            this.schedulingForm.classesName = res.data.classesName
            this.schedulingForm.address = res.data.address
            for (let i = 0; i < res.data.manages.length; i++) {
              this.schedulingForm.manageIds.push(res.data.manages[i].userId)
            }
            for (let i = 0; i < res.data.users.length; i++) {
              this.schedulingForm.userIds.push(res.data.users[i].userId)
            }
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getSchedulingListData()
    },
    // 刷新数据表格
    refresh() {
      this.getSchedulingListData()
      this.$message.success('数据刷新成功')
    },
    // 班次详情
    detailShow(id) {
      this.drawer = true
      getSchedulingDetail(id).then(res => {
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取排班列表
    getSchedulingListData() {
      this.loading = true
      getSchedulingList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getSchedulingListData()
    // 获取班次列表
    getClassesList({
      page: 1,
      size: 1000,
      userType: 1
    }).then(res => {
      if (res.status === 1) {
        this.classesList = res.data.rows
      }
    })
    // 获取员工列表
    getUserList({
      page: 1,
      size: 1000,
      userType: 2
    }).then(res => {
      if (res.status === 1) {
        this.manageList = res.data.rows
        this.userList = res.data.rows
      }
    })
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
